// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_2h-6";
export var headerCell = "_2h-2";
export var loadingStateContent = "_2h-8";
export var rowWrapper = "_2h-4";
export var stickyAggregationCell = "_2h-b";
export var stickyAggregationRow = "_2h-7";
export var stickyColumnCell = "_2h-a";
export var stickyColumnHeaderCell = "_2h-9";
export var table = "_2h-1";
export var virtualRowWrapper = "_2h-5";
export var virtualTableContainer = "_2h-0";
export var white = "_2h-3";